import { Button, ButtonProps } from '@mui/material';
import axios from 'axios';
import { requestLogout } from '../../asyncHelpers/authService';
import { useAppDispatch } from '../../store/hooks';
import { clearAuth } from '../../store/users';

type Props = ButtonProps & {};

export const ButtonLogout = ({ ...rest }: Props) => {
    //logout function
    const request_token = axios.CancelToken.source();
    const dispatch = useAppDispatch();

    const handleLogout = async (e: any) => {
        try {
            await requestLogout(request_token.token);
            dispatch(clearAuth());
        } catch (e: any) {
            // console.log("error logout", e.response);
        }
        //ya... this is filthy
        document.location.reload();
    };

    return (
        <Button onClick={handleLogout} variant="outlined" {...rest}>
            Log Out
        </Button>
    );
};
